import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import lottie, { AnimationItem } from 'lottie-web';

import ScrollGuideAnimation from '../json/scroll_guide_icon.json';

export const ScrollGuideIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
  const animation_container = useRef<HTMLDivElement>(null);
  const animation_ref = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (animation_container.current) {
      animation_ref.current = lottie.loadAnimation({
        container: animation_container.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: ScrollGuideAnimation,
      });
    }

    return () => {
      if (animation_ref.current) {
        animation_ref.current.destroy();
      }
    };
  }, []);

  return (
    <Icon>
      <div ref={animation_container} />
    </Icon>
  );
};

const Icon = styled.div`
  width: 32px;
  height: 85.33px;
  margin-bottom: 4px;
`;
